import React from 'react';

import { AppIcon, IconName } from '../../../../../components/icons/AppIcon';

interface MediaFallbackProps {
    type: string;
    fallbackLabel?: string;
    /** Mesmo ciclo do texto: pending/uncertain → Enviando; failed → indisponível; senão Carregando. */
    status?: string;
}

const icons: Record<string, { icon: IconName; label: string }> = {
    image: { icon: 'image', label: 'Imagem' },
    video: { icon: 'video', label: 'Vídeo' },
    audio: { icon: 'mic', label: 'Áudio' },
    sticker: { icon: 'smile', label: 'Figurinha' },
    location: { icon: 'location', label: 'Localização' },
    contact: { icon: 'user', label: 'Contato' },
    poll: { icon: 'chart', label: 'Enquete' },
    document: { icon: 'file-text', label: 'Documento' },
    pix: { icon: 'pix', label: 'Pix' },
};

/** Ícone de tipo de mídia (fonte única p/ quote/reply/edit/fallback). */
export function chatMediaIconName(type: string): IconName | undefined {
    return icons[type]?.icon;
}

function fallbackCopy(typeLabel: string, status?: string): string {
    // Só “indisponível” em falha explícita — nunca por status vazio (flash de 1 frame).
    if (status === 'failed') return `${typeLabel} indisponível`;
    if (status === 'pending' || status === 'uncertain') return 'Enviando…';
    return 'Carregando…';
}

/** Placeholder enquanto a URL durável não chegou — checks ficam no overlay/footer do balão. */
export const MediaFallback: React.FC<MediaFallbackProps> = ({ type, fallbackLabel, status }) => {
    const { icon, label } = icons[type] || { icon: 'file-text' as IconName, label: 'Mídia' };

    return (
        <div className="p-3 flex items-center gap-3 bg-white/20 rounded-lg border border-white/30 m-1 min-w-[150px]">
            <div className="text-white/80">
                <AppIcon name={icon} className="w-6 h-6" />
            </div>
            <span className="text-sm text-white/80 italic">
                {fallbackLabel || fallbackCopy(label, status)}
            </span>
        </div>
    );
};
